/**
 * The verbosity level of a log entry
 */
export let LogLevel;

/**
 * A log entry representation
 */
(function (LogLevel) {
  LogLevel[LogLevel["Verbose"] = 0] = "Verbose";
  LogLevel[LogLevel["Debug"] = 1] = "Debug";
  LogLevel[LogLevel["Information"] = 2] = "Information";
  LogLevel[LogLevel["Warning"] = 3] = "Warning";
  LogLevel[LogLevel["Error"] = 4] = "Error";
  LogLevel[LogLevel["Fatal"] = 5] = "Fatal";
})(LogLevel || (LogLevel = {}));
/**
 * Interface that represents a log entry with a specific level
 */
//# sourceMappingURL=log-entries.js.map